// React
import { useHistory } from 'react-router-dom';
import 'cleave.js/dist/addons/cleave-phone.in';
import React, { useEffect, useState } from 'react';
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  Input,
  Label,
  Row,
} from 'reactstrap';

// Hooks
import { useLoading } from '../../../hook/useLoading';

// Validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// Components
import Section from './Section';
import { PageWrapper } from '../../../components/pageWrapper';

// Redux
import {
  CostCenter,
  CreateCostCenter,
  UpdateCostCenter,
} from '../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';

const CostCenterForm = () => {
  const [costCenter, setCostCenter] = useState(null);

  const history = useHistory();

  const { costCenters } = useSelector((state) => ({
    costCenters: state.CostCenter.costCenters,
  }));

  const dispatch = useDispatch();
  const { loadingWithTime } = useLoading();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      nameInput: costCenter ? costCenter.name : '',
      isActive: costCenter ? costCenter.active : true,
    },
    validationSchema: Yup.object({
      nameInput: Yup.string().required('Nome é obrigatório'),
      isActive: Yup.boolean().nullable(),
    }),
    onSubmit: (values) => {
      const valuesToSubmit = {
        name: values.nameInput || null,
        active: values.isActive,
      };

      loadingWithTime(1000);
      if (costCenter) {
        dispatch(UpdateCostCenter(costCenter.id, valuesToSubmit));
      } else {
        dispatch(CreateCostCenter(valuesToSubmit));
      }
      history.goBack();
    },
  });

  useEffect(() => {
    dispatch(CostCenter());
  }, [dispatch]);

  useEffect(() => {
    const full_url = document.URL; // Get current url
    const url_array = full_url.split('/'); // Split the string into an array with / as separator
    const last_segment = url_array[url_array.length - 1];
    findCostCenter(last_segment);
  }, [costCenters]);

  const findCostCenter = (id) => {
    const costCenter = costCenters.find((associate) => associate.id === id);

    if (costCenter) {
      setCostCenter(costCenter);
    }
  };

  return (
    <PageWrapper title={'Centro de Custos'}>
      <Row>
        <Col>
          <Card>
            <div className="live-preview">
              <Form
                autoComplete="off"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <CardBody>
                  <Section />

                  <Row>
                    <Col md={12}>
                      <div className="mb-3">
                        <Label htmlFor="name" className="form-label">
                          Nome
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          id="nameInput"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.nameInput || ''}
                        />
                        {validation.touched.nameInput &&
                        validation.errors.nameInput ? (
                          <p className="labelErrorValidation">
                            {validation.errors.nameInput}
                          </p>
                        ) : null}
                      </div>
                    </Col>

                    <Col md={12}>
                      <div>
                        <div className="form-check form-switch mb-3">
                          <Input
                            className="form-check-input"
                            type="checkbox"
                            role="switch"
                            id="isActive"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            checked={validation.values.isActive}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="isActive"
                          >
                            Ativo
                          </Label>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardBody>

                <CardFooter>
                  <Col md={12}>
                    <div className="text-end d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-link"
                        style={{
                          marginRight: '10px',
                        }}
                        onClick={() => {
                          history.goBack();
                        }}
                      >
                        Cancelar
                      </button>
                      <button type="submit" className="btn btn-primary">
                        Salvar
                      </button>
                    </div>
                  </Col>
                </CardFooter>
              </Form>
            </div>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};

export default CostCenterForm;
